import { render, staticRenderFns } from "./HomeStandalone.vue?vue&type=template&id=a3e36416&scoped=true&"
import script from "./HomeStandalone.vue?vue&type=script&lang=js&"
export * from "./HomeStandalone.vue?vue&type=script&lang=js&"
import style0 from "./HomeStandalone.vue?vue&type=style&index=0&id=a3e36416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e36416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3e36416')) {
      api.createRecord('a3e36416', component.options)
    } else {
      api.reload('a3e36416', component.options)
    }
    module.hot.accept("./HomeStandalone.vue?vue&type=template&id=a3e36416&scoped=true&", function () {
      api.rerender('a3e36416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/HomeStandalone.vue"
export default component.exports